/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useState, useContext, useRef } from 'react';
import './Measure.scss';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import measureHelper from '../helper/measureHelper';
import { MapContext } from '../map/MapContextProvider';
import { ActionContext } from '../action/ActionContextProvider';
import actionEnums from '../helper/actionEnums';
import { CustomDrawingManager, OverlayType } from '../helper/CustomDrawingManager';

/*global google*/
export default function MeasureComponent() {
    const { map } = useContext(MapContext);

    const { selectedAction } = useContext(ActionContext);

    const measurePanelRef = useRef();

    const [drawManager, setDrawManager] = useState();
    const [calculationResult, setCalculationResult] = useState();
    const [calculationText, setCalculationText] = useState();
    const [geom, setGeom] = useState();
    const [unit, setUnit] = useState('metric');

    const mhelper = new measureHelper();

    useEffect(() => {
        if (map) {
            startDrawing();

            map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].clear();
            map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(measurePanelRef.current);
        }
    }, [map]);

    useEffect(() => {
        if (selectedAction == actionEnums.measurePolyline.action) {
            distanceMeasure();
        } else if (selectedAction == actionEnums.measurePolygon.action) {
            areaMeasure();
        } else if (selectedAction == actionEnums.clearMeasure.action) {
            clearMeasure();
        } else {
            clearMeasure();
        }
    }, [selectedAction]);

    useEffect(() => {
        let messageText = '';
        if (selectedAction == actionEnums.measurePolyline.action) {
            messageText = mhelper.formatLength(calculationResult);
        } else if (selectedAction == actionEnums.measurePolygon.action) {
            messageText = mhelper.formatArea(calculationResult);
        }

        setCalculationText(messageText);
    }, [calculationResult]);

    useEffect(() => {
        mhelper.initUnits(unit);

        let messageText = '';
        if (selectedAction == actionEnums.measurePolyline.action) {
            messageText = mhelper.formatLength(calculationResult);
        } else if (selectedAction == actionEnums.measurePolygon.action) {
            messageText = mhelper.formatArea(calculationResult);
        }

        setCalculationText(messageText);
    }, [unit]);

    function distanceMeasure() {
        geom?.setMap(null);
        const measurePanel = measurePanelRef.current;
        measurePanel.style.display = 'block';
        drawManager.setDrawingMode(OverlayType.POLYLINE);
    }

    function areaMeasure() {
        geom?.setMap(null);
        const measurePanel = measurePanelRef.current;
        measurePanel.style.display = 'block';
        drawManager.setDrawingMode(OverlayType.POLYGON);
    }

    function clearMeasure() {
        geom?.setMap(null);
        const measurePanel = measurePanelRef.current;
        measurePanel.style.display = 'none';
        drawManager?.setDrawingMode(null);
        setCalculationResult(null);
    }

    const newMeasurement = () => {
        if (selectedAction == actionEnums.measurePolyline.action) distanceMeasure();
        else if (selectedAction == actionEnums.measurePolygon.action) areaMeasure();

        setCalculationResult(null);
    };

    const startDrawing = () => {
        const polylineStyleOpts = {
            strokeColor: '#2C5D81',
            fillColor: '#007eb6',
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            scale: 4,
            zIndex: 103
        };

        const ploygonStyleOpts = {
            strokeColor: '#2C5D81',
            fillColor: '#007eb6',
            fillOpacity: 0.8,
            visible: true,
            zIndex: 104
        };

        if (map) {
            let drawMgr = drawManager;
            if (!drawMgr) {
                drawMgr = new CustomDrawingManager({
                    polygonOptions: ploygonStyleOpts,
                    polylineOptions: polylineStyleOpts
                });

                setDrawManager(drawMgr);
            }

            drawMgr.setMap(map);

            drawMgr.addListener('polygoncomplete', (poly) => {
                setGeom(poly);
                console.log(poly);
                var AreaInMeters = google.maps.geometry.spherical.computeArea(poly.getPath());
                setCalculationResult(AreaInMeters);
                drawMgr.setDrawingMode(null);
            });

            drawMgr.addListener('polylinecomplete', (poly) => {
                setGeom(poly);
                var lengthInMeters = google.maps.geometry.spherical.computeLength(poly.getPath());
                setCalculationResult(lengthInMeters);
                drawMgr.setDrawingMode(null);
            });
        }
    };

    const handleUnitChange = (event) => {
        setUnit(event.target.value);
    };
    return (
        <>
            <div ref={measurePanelRef} className="panel-measure">
                {!calculationResult && <div> Start to measure by clicking in the map to place your first point</div>}
                {calculationResult && (
                    <>
                        <div>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Unit</InputLabel>
                                <Select
                                    labelId="unit-select-label"
                                    id="unit-select-id"
                                    value={unit}
                                    label="Unit"
                                    onChange={handleUnitChange}
                                >
                                    <MenuItem value="metric">Metric</MenuItem>
                                    <MenuItem value="imperial">Imperial</MenuItem>
                                    <MenuItem value="miles">Miles</MenuItem>
                                </Select>
                            </FormControl>

                            <div className="measurement-text"> {calculationText} </div>
                            <Button onClick={newMeasurement}>New Measurement</Button>
                            <Button onClick={clearMeasure}>Clear Measurement</Button>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}
